import { Box, useTheme } from '@mui/material';

import { AnnotatorQueueContent } from './components/AnnotatorQueueContent';
import { AnnotatorQueueHeader } from './components/AnnotatorQueueHeader';

export const AnnotatorQueue = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        pl: theme.spacing(6),
        pr: theme.spacing(6),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(6),
      }}
    >
      <AnnotatorQueueHeader />
      <AnnotatorQueueContent />
    </Box>
  );
};
